__turbopack_context__.v({
  "icon-item": "ogy_ba_icon-item",
  "icon-item-svg": "ogy_ba_icon-item-svg",
  "icon-list-item": "ogy_ba_icon-list-item",
  "no-margin-bottom": "ogy_ba_no-margin-bottom",
});
